import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { setSearchSingleOrderUnvId, setGobackReportingsUrl, resetOrdersAndCustomersStore, setSelectedOrderUnvId } from '@pages/orders/store/slice';



export const useMaterialGridOrderClick = () => {
	
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const updateSearchSingleOrderUnvId = (value: string) => dispatch(setSearchSingleOrderUnvId(value));
	const updateGobackReportingsUrl = (url: string) => dispatch(setGobackReportingsUrl(url));
	const dispatchResetOrdersAndCustomersStore = () => dispatch(resetOrdersAndCustomersStore());
	const dispatchSetSelectedOrderUnvId = (orderUnvId: string | null) => dispatch(setSelectedOrderUnvId(orderUnvId));

	
	const clickToOrder = useCallback((orderUnvId: string) => {
		if (orderUnvId) {
			updateSearchSingleOrderUnvId(orderUnvId);
			updateGobackReportingsUrl(location.pathname + location.search);
			location.pathname === NavigateRoutesEnum.search
				? dispatchSetSelectedOrderUnvId(null)
				: dispatchResetOrdersAndCustomersStore();
			navigate(NavigateRoutesEnum.search);
		}
	},[ location ]);

	
	return clickToOrder;
}